import { Injectable } from '@angular/core';
import { IPermission } from '../models';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private localStorageService;

  constructor() { 
    this.localStorageService = localStorage;
  }

  GetToken() {
    return JSON.parse(this.localStorageService.getItem('currentUser')).access_token;
  }

  SetCurrentSession(currentUser): void {
    this.localStorageService.setItem('currentUser', JSON.stringify(currentUser));
  }

  GetCurrentSession(): any {
    return JSON.parse(this.localStorageService.getItem('currentUser'));
  }

  ClearCurrentSession() {
    this.localStorageService.removeItem('currentUser');
  }

  SetPermissions(_permissions: IPermission[]): void {
    this.localStorageService.setItem('Perms', JSON.stringify(_permissions));
  }

  GetPermissions(): IPermission[] {
    const PERMISSIONS = JSON.parse(this.localStorageService.getItem('Perms')) as IPermission[];
    if (PERMISSIONS !== null) return PERMISSIONS;
    return [];
  }

  ClearPermissions() {
    this.localStorageService.removeItem('currentUser');
  }

}
